module.exports = __webpack_public_path__ + "img/generali.d068737a.png";